import React, { useState, useEffect } from "react";
import SecretaireDataService from "../services/secretaire.service";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid, regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { iconMap } from '../utils/iconMap';
import Carousel from 'react-bootstrap/Carousel';
import { useAuth0 } from '@auth0/auth0-react';
import { useToast } from './common/Toast';
import logger from '../utils/logger';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const HomeSec = () => {
  const { getAccessTokenSilently, user } = useAuth0();
  const { showSuccess, showError, showWarning } = useToast();
  
  const [state, setState] = useState({
    tmed: [],
    trdv: [],
    patient: '',
    doc: '',
    idrdv: '',
    structure: '',
    dateplagerdv: '',
    showModalRdvEffet: false,
    showModalCancelRdvEffet: false,
    selectedFrame: 'accueil',
    weekDay: {"1":"Dimanche","2":"Lundi","3":"Mardi","4":"Mercredi","5":"Jeudi","6":"Vendredi","7":"Samedi"},
    weekDay2: {"1":"Dim","2":"Lun","3":"Mar","4":"Mer","5":"Jeu","6":"Ven","7":"Sam"},
    months: {"01":"Janvier","02":"Février","03":"Mars","04":"Avril","05":"Mai","06":"Juin","07":"Juillet","08":"Août","09":"Septembre","10":"Octobre","11":"Novembre","12":"Décembre"} 
  });

  const getSecMed = async () => {
    try {
      const response = await SecretaireDataService.secmed(user.email);
      setState(prev => ({
        ...prev,
        tmed: response.data
      }));
      logger.log('Médecins secrétaire récupérés:', response.data);
    } catch (e) {
      logger.error('Erreur récupération médecins secrétaire:', e);
      showError('Erreur lors de la récupération des médecins', 'error'); 
    }
  };

  const getSecMedRdv = async () => {
    try {
      const response = await SecretaireDataService.secmedrdv2(user.email);
      setState(prev => ({
        ...prev,
        trdv: response.data
      }));
      logger.log('RDV secrétaire récupérés:', response.data);
    } catch (e) {
      logger.error('Erreur récupération RDV secrétaire:', e);
      showError('Erreur lors de la récupération des rendez-vous', 'error'); 
    }
  };

  const handleSelectChange = (event) => {
    setState(prev => ({
      ...prev,
      selectedFrame: event.target.value
    }));
  };

  // Méthode pour rendre la cellule de statut
  const renderStatutCell = (appointment, doc) => {
    const statutLibelle = appointment.statut_rdv.split("_")[1];
    const statutStyle = appointment.statut_rdv.split("_")[0];
    const statutIcone = appointment.statut_rdv.split("_")[2];
    const statutTime = appointment.statut_rdv.split("_")[3];
    
    switch (statutLibelle) {
      case 'Manqué':
        if (new Date(appointment.drdv2) < new Date(Date.now() - 10 * 24 * 60 * 60 * 1000)) {
          //date antérieure aux 10 derniers jours donc statut rdv immuable
          return (
            <td className={statutStyle}>
              <FontAwesomeIcon icon={iconMap[statutIcone]} />{' '}
              <span title={"Rendez-vous " + statutLibelle.toLowerCase()}>{statutLibelle}</span>
            </td>
          );
        }
        else {
          //date comprise dans les 10 derniers jours donc statut rdv encore modifiable 
          return (
            <td className={statutStyle}>
              <div className="dropdown" title={"Rendez-vous " + statutLibelle.toLowerCase()}>
                <button style={{ color: 'inherit', textDecoration: 'none', padding: 0 }} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <FontAwesomeIcon icon={iconMap[statutIcone]} /> {statutLibelle}
                </button>
                <ul className="dropdown-menu">
                  <li key={appointment.id + '_mark_done'}>
                    <button 
                      className="dropdown-item" 
                      type="button" 
                      onClick={() => handleShowRdvEffet(
                        appointment.id, 
                        'Patient '+appointment.nom+' '+appointment.prenom, 
                        appointment.libelle_structure, 
                        'Rendez-vous du '+appointment.drdv+' entre '+appointment.hdeb+' et '+appointment.hfin, 
                        doc
                      )}
                    >
                      Marquer comme effectué
                    </button>
                  </li>
                </ul>
              </div>
            </td>
          );
        }
      case 'En attente':
        if(appointment.drdv2>new Date().toISOString().split('T')[0]) {
          return (
            <td className={statutStyle}>
              <FontAwesomeIcon icon={iconMap[statutIcone]} />{' '}
              <span title={"Rendez-vous " + statutLibelle.toLowerCase()}>{statutLibelle}</span>
            </td>
          );
        }
        else {
          return (
            <td className={statutStyle}>
              <div className="dropdown" title={"Rendez-vous " + statutLibelle.toLowerCase()}>
                <button style={{ color: 'inherit', textDecoration: 'none', padding: 0 }} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <FontAwesomeIcon icon={iconMap[statutIcone]} /> {statutLibelle}
                </button>
                <ul className="dropdown-menu">
                  <li key={appointment.id + '_mark_done'}>
                    <button 
                      className="dropdown-item" 
                      type="button" 
                      onClick={() => handleShowRdvEffet(
                        appointment.id, 
                        'Patient '+appointment.nom+' '+appointment.prenom, 
                        appointment.libelle_structure, 
                        'Rendez-vous du '+appointment.drdv+' entre '+appointment.hdeb+' et '+appointment.hfin, 
                        doc
                      )}
                    >
                      Marquer comme effectué
                    </button>
                  </li>
                </ul>
              </div>
            </td>
          );
        }
      case 'Effectué':
        if (new Date(appointment.drdv2) < new Date(Date.now() - 10 * 24 * 60 * 60 * 1000)) {
          //date antérieure aux 10 derniers jours donc statut rdv immuable
          return (
            <td className={statutStyle}>
              <FontAwesomeIcon icon={iconMap[statutIcone]} />{' '}
              <span title={"Rendez-vous " + statutLibelle.toLowerCase() + (statutTime ? " le " + statutTime : '')}>
                {statutLibelle}
              </span>
            </td>
          );
        }
        else {
          //date comprise dans les 10 derniers jours donc statut rdv encore modifiable 
          return (
            <td className={statutStyle}>
              <div className="dropdown" title={"Rendez-vous " + statutLibelle.toLowerCase() + (statutTime ? " le " + statutTime : '')}>
                <button style={{ color: 'inherit', textDecoration: 'none', padding: 0 }} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <FontAwesomeIcon icon={iconMap[statutIcone]} /> {statutLibelle}
                </button>
                <ul className="dropdown-menu">
                  <li key={appointment.id + '_mark_done'}>
                    <button 
                      className="dropdown-item" 
                      type="button" 
                      onClick={() => handleShowCancelRdvEffet(
                        appointment.id, 
                        'Patient '+appointment.nom+' '+appointment.prenom, 
                        appointment.libelle_structure, 
                        'Rendez-vous du '+appointment.drdv+' entre '+appointment.hdeb+' et '+appointment.hfin, 
                        doc
                      )}
                    >
                      Annuler
                    </button>
                  </li>
                </ul>
              </div>
            </td>
          );
        }
      default:
        return (
          <td className={statutStyle}>
            <FontAwesomeIcon icon={iconMap[statutIcone]} />{' '}
            <span title={"Rendez-vous " + statutLibelle.toLowerCase() + (statutTime ? " le " + statutTime : '')}>
              {statutLibelle}
            </span>
          </td>
        );
    }
  };

  //Fonction rdv effectif
  const handleShowRdvEffet = (idrdv, patient, structure, dateplagerdv, doc) => {
    setState(prev => ({
      ...prev,
      idrdv: idrdv,
      patient: patient,
      doc: doc,
      structure: structure,
      dateplagerdv: dateplagerdv,
      showModalRdvEffet: true
    }));
  };

  const handleCloseRdvEffet = () => {
    setState(prev => ({
      ...prev,
      showModalRdvEffet: false
    }));
  };

  const handleSubmitRdvEffet = async (event) => {
    event.preventDefault();
    try {
      await SecretaireDataService.effetRdv(user.email, state.idrdv);
      getSecMedRdv();
      handleCloseRdvEffet();
      showSuccess('Rendez-vous marqué comme effectué', 'success'); 
    } catch (e) {
      logger.error('Erreur marquage RDV effectué:', e);
      showError('Erreur lors du marquage du rendez-vous', 'error'); 
    }
  };

  //Fonction cancel rdv effectif
  const handleShowCancelRdvEffet = (idrdv, patient, structure, dateplagerdv, doc) => {
    setState(prev => ({
      ...prev,
      idrdv: idrdv,
      patient: patient,
      doc: doc,
      structure: structure,
      dateplagerdv: dateplagerdv,
      showModalCancelRdvEffet: true
    }));
  };

  const handleCloseCancelRdvEffet = () => {
    setState(prev => ({
      ...prev,
      showModalCancelRdvEffet: false
    }));
  };

  const handleSubmitCancelRdvEffet = async (event) => {
    event.preventDefault();
    try {
      await SecretaireDataService.cancelEffetRdv(user.email, state.idrdv);
      getSecMedRdv();
      handleCloseCancelRdvEffet();
      showSuccess('Rendez-vous annulé avec succès', 'success'); 
    } catch (e) {
      logger.error('Erreur annulation RDV effectué:', e);
      showError('Erreur lors de l\'annulation du rendez-vous', 'error'); 
    }
  };

  useEffect(() => {
    const initializeComponent = async () => {
      try {
        const token = await getAccessTokenSilently({
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: "openid profile email"
        });
        
        // Configurer le token pour axios
        const http = require("../http-common").default;
        http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        getSecMed();
        getSecMedRdv();
      } catch (error) {
        logger.error('Erreur récupération token:', error);
        showError('Erreur d\'authentification', 'error'); 
      }
    };

    initializeComponent();
  }, [getAccessTokenSilently, user]);

  const { tmed, trdv, selectedFrame, weekDay, weekDay2, months, showModalRdvEffet, showModalCancelRdvEffet, patient, doc, structure, dateplagerdv } = state;

  return (
    <div className="col-md-12 mx-auto">
      <table style={{width:"100%"}}>
        <tbody>
          <tr style={{backgroundColor:"#6f42c1"}}>
            <td style={{padding:"10px"}}>
              <table style={{color:"white"}}>
                <tbody>
                  <tr>
                    <td style={{padding:"5px"}}>
                      <FontAwesomeIcon icon={solid('calendar-days')} size="2x"/>
                    </td>
                    <td style={{padding:"5px"}}>
                      <span style={{fontSize:"1.5rem"}} className="lead"><b>Liste des rendez-vous</b></span><br/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr> 
        </tbody>
      </table>
      <div className="col-md-12 mx-auto" style={{padding:"10px"}}>
        <Modal show={showModalRdvEffet} onHide={handleCloseRdvEffet}>
          <Modal.Header closeButton>
            <Modal.Title>Effectuer un rendez-vous</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <input type="text" className="form-control" value={patient} readOnly/>
            </div>
            <div className="mb-3">
              <input type="text" className="form-control" value={doc} readOnly/>
            </div>
            <div className="mb-3">
              <input type="text" className="form-control" value={structure} readOnly/>
            </div>
            <div className="mb-3">
              <input type="text" className="form-control" value={dateplagerdv} readOnly/>
            </div>
            <p className="text-danger" align="center">Voulez-vous marquer ce rendez-vous comme étant effectif?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={handleSubmitRdvEffet}>
              Valider
            </Button>
            <Button variant="secondary" onClick={handleCloseRdvEffet}>
              Annuler
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showModalCancelRdvEffet} onHide={handleCloseCancelRdvEffet}>
          <Modal.Header closeButton>
            <Modal.Title>Annuler un rendez-vous</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <input type="text" className="form-control" value={patient} readOnly/>
            </div>
            <div className="mb-3">
              <input type="text" className="form-control" value={doc} readOnly/>
            </div>
            <div className="mb-3">
              <input type="text" className="form-control" value={structure} readOnly/>
            </div>
            <div className="mb-3">
              <input type="text" className="form-control" value={dateplagerdv} readOnly/>
            </div>
            <p className="text-danger" align="center">Voulez-vous annuler ce rendez-vous ?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={handleSubmitCancelRdvEffet}>
              Valider
            </Button>
            <Button variant="secondary" onClick={handleCloseCancelRdvEffet}>
              Annuler
            </Button>
          </Modal.Footer>
        </Modal>
        <table style={{width:"100%"}}>
          <tbody>
            <tr>
              <td>
                <select className="form-select form-select-lg mb-3" aria-label="Large select example" id="frame-select" value={selectedFrame} onChange={handleSelectChange}>
                  <option key="accueil" value="accueil">Veuillez sélectionner un médecin</option>
                  {tmed && tmed.map((med) => (
                      <option key={med.id_medecin} value={med.id_medecin}>{med.titre+' '+med.nom+' '+med.prenom}</option>
                  ))}
                </select>   
              </td>
            </tr> 
          </tbody>
        </table>
        <div>
          <div key="accueil" style={{display: selectedFrame === "accueil" ? 'block' : 'none'}}>
            <p>Vous n'avez sélectionné aucun médecin.</p>
          </div>
          {trdv && trdv.map((item) => (
              Object.entries(item.trdv_json).map(([doctorId, mydata]) => (
              <div key={doctorId} style={{display: selectedFrame === doctorId ? 'block' : 'none'}}>
                  {mydata.rendez_vous && mydata.rendez_vous.length > 0 ? (
                  <React.Fragment key={`groupe_${doctorId}`}>
                    <nav id="navbar-example2" className="navbar bg-body-tertiary px-3 mb-3">
                      <ul className="nav nav-pills">
                        <li className="nav-item">
                          <a className="nav-link" href="#aujourdhui">Aujourd'hui</a>
                        </li>
                      </ul>
                    </nav>
                    <table className="table table-hover table-striped">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Plage</th>
                                <th>Lieu</th>
                                <th>Patient</th>
                                <th>Statut</th>
                            </tr>
                        </thead>
                        <tbody>
                        {mydata.rendez_vous.map((appointment, index) => {
                          if(appointment.drdv2!==mydata.rendez_vous[index - 1]?.drdv2 && appointment.drdv2===new Date().toISOString().split('T')[0]) {
                            return (<tr id="aujourdhui" key={index}>
                            <td>{appointment.drdv}</td>
                            <td>{appointment.hdeb+' - '+appointment.hfin}</td>
                            <td>{appointment.libelle_structure}</td>
                            <td>{appointment.nom+' '+appointment.prenom}</td>
                              {renderStatutCell(appointment, mydata.titre+' '+mydata.nom_medecin+' '+mydata.prenom_medecin)}
                            </tr>)
                          }
                          else {
                            return (<tr key={index}>
                            <td>{appointment.drdv}</td>
                            <td>{appointment.hdeb+' - '+appointment.hfin}</td>
                            <td>{appointment.libelle_structure}</td>
                            <td>{appointment.nom+' '+appointment.prenom}</td>
                              {renderStatutCell(appointment, mydata.titre+' '+mydata.nom_medecin+' '+mydata.prenom_medecin)}
                            </tr>)
                            }
                        })}
                        
                        </tbody>
                    </table>
                  </React.Fragment>
                  ) : (
                  <p>Aucun rendez-vous pour ce medeçin.</p>
                  )}
              </div>
              ))

          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeSec;